import { render, staticRenderFns } from "./LBtn.vue?vue&type=template&id=4a742396&scoped=true"
import script from "./LBtn.vue?vue&type=script&lang=js"
export * from "./LBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a742396",
  null
  
)

export default component.exports